/**
 * TTQAS (品题答题纸) QR payload parser — aligned with Mobile2.
 */

export type TtqasQrFormat = 'ttqas_json_v1' | 'detail_url' | 'particle_id';

export type TtqasQrAnchor = {
  kpId: string;
  ttqaId: string;
  sessionId?: string;
  batch?: string;
  format: TtqasQrFormat;
  raw: string;
};

function asNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

function parseTtqasJsonV1(payload: string): TtqasQrAnchor | null {
  const trimmed = payload.trim();
  if (!trimmed.startsWith('{')) return null;

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return null;
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
  const record = parsed as Record<string, unknown>;
  const version = record.v;
  if (version !== 1 && version !== '1') return null;

  const kind = asNonEmptyString(record.kind);
  if (kind && kind !== 'ttqas') return null;

  const kpId = asNonEmptyString(record.kpId);
  const ttqaId = asNonEmptyString(record.ttqaId);
  if (!kpId || !ttqaId) return null;

  return {
    kpId,
    ttqaId,
    sessionId: asNonEmptyString(record.sessionId) || undefined,
    batch: asNonEmptyString(record.batch) || undefined,
    format: 'ttqas_json_v1',
    raw: trimmed,
  };
}

export function parseTtqasQrPayload(payload: string): TtqasQrAnchor | null {
  const trimmed = String(payload || '').trim();
  if (!trimmed) return null;
  return parseTtqasJsonV1(trimmed);
}
